import React from 'react';
import { Link, useHistory } from "react-router-dom";
import { FaHouse, FaLocationDot, FaPhone, FaInfo, FaImages, FaGear } from 'react-icons/fa6';

export default function Sidebar({ handleLogout, isLoggedIn, sidebarOpen }) {
    const navigate = useHistory();
    const api = "https://apibbytowing.vercel.app";

    return (
        <div className={`fixed z-50 translate-y-14 transition-transform duration-300 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
            <div className="relative flex flex-col bg-clip-border rounded-b-xl bg-white text-gray-700 h-screen w-full p-4 shadow-xl shadow-yellow-gray-900/5">
                <nav className="flex flex-col gap-1 min-w-[240px] p-2 font-sans text-base font-normal text-gray-700">
                    <Link to="/" className="flex items-center w-full p-3 rounded-lg text-start leading-tight transition-all hover:bg-[#FCFC00] hover:bg-opacity-80 focus:bg-[#FCFC00] focus:bg-opacity-80 active:bg-gray-50 active:bg-opacity-80 hover:text-black focus:text-black active:text-black outline-none">
                        <div className="grid place-items-center mr-4">
                            <FaHouse />
                        </div>
                        Home
                    </Link>
                    <a href="#about" className="flex items-center w-full p-3 rounded-lg text-start leading-tight transition-all hover:bg-[#FCFC00] hover:bg-opacity-80 focus:bg-[#FCFC00] focus:bg-opacity-80 active:bg-[#FCFC00] active:bg-opacity-80 hover:text-black focus:text-black active:text-black outline-none">
                        <div className="grid place-items-center mr-4">
                            <FaInfo />
                        </div>
                        About
                    </a>
                    <a href="#service" className="flex items-center w-full p-3 rounded-lg text-start leading-tight transition-all hover:bg-[#FCFC00] hover:bg-opacity-80 focus:bg-[#FCFC00] focus:bg-opacity-80 active:bg-[#FCFC00] active:bg-opacity-80 hover:text-black focus:text-black active:text-black outline-none">
                        <div className="grid place-items-center mr-4">
                            <FaGear />
                        </div>
                        Service
                    </a>
                    <Link to="/gallery" className="flex items-center w-full p-3 rounded-lg text-start leading-tight transition-all hover:bg-[#FCFC00] hover:bg-opacity-80 focus:bg-[#FCFC00] focus:bg-opacity-80 active:bg-[#FCFC00] active:bg-opacity-80 hover:text-black focus:text-black active:text-black outline-none">
                        <div className="grid place-items-center mr-4">
                            <FaImages />
                        </div>
                        Gallery
                    </Link>
                    <a href="#location" className="flex items-center w-full p-3 rounded-lg text-start leading-tight transition-all hover:bg-[#FCFC00] hover:bg-opacity-80 focus:bg-[#FCFC00] focus:bg-opacity-80 active:bg-[#FCFC00] active:bg-opacity-80 hover:text-black focus:text-black active:text-black outline-none">
                        <div className="grid place-items-center mr-4">
                            <FaLocationDot />
                        </div>
                        Location
                    </a>
                    <a href="https://wa.me/+6282288349889" target='_blank' className="flex items-center w-full p-3 rounded-lg text-start leading-tight transition-all hover:bg-[#FCFC00] hover:bg-opacity-80 focus:bg-[#FCFC00] focus:bg-opacity-80 active:bg-[#FCFC00] active:bg-opacity-80 hover:text-black focus:text-black active:text-black outline-none">
                        <div className="grid place-items-center mr-4">
                            <FaPhone />
                        </div>
                        Contact
                    </a>
                    {isLoggedIn && (
                        <button onClick={handleLogout} className="flex items-center w-full p-3 rounded-lg text-start leading-tight transition-all hover:bg-[#FCFC00] hover:bg-opacity-80 focus:bg-[#FCFC00] focus:bg-opacity-80 active:bg-[#FCFC00] active:bg-opacity-80 hover:text-black focus:text-black active:text-black outline-none">
                            <div className="grid place-items-center mr-4">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="h-5 w-5">
                                    <path fillRule="evenodd" d="M12 2.25a.75.75 0 01.75.75v9a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM6.166 5.106a.75.75 0 010 1.06 8.25 8.25 0 1011.668 0 .75.75 0 111.06-1.06c3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788a.75.75 0 011.06 0z" clipRule="evenodd"></path>
                                </svg>
                            </div>
                            Log Out
                        </button>
                    )}
                </nav>
            </div>
        </div>
    );
}
